import { render } from "./BaseLightBox.vue?vue&type=template&id=b4d93b5a&scoped=true"
import script from "./BaseLightBox.vue?vue&type=script&lang=js"
export * from "./BaseLightBox.vue?vue&type=script&lang=js"

import "./BaseLightBox.vue?vue&type=style&index=0&id=b4d93b5a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4d93b5a"]])

export default __exports__